angular.module('pims').filter('tooltipifyLinks', () => (textCopy) => {
  let regex = new RegExp('{{(?<tag>[A-Z_]+) to="(?<to>.*?)" text="(?<text>.*?)" data="(?<data>.*?)"}}', 'g');
  const mustacheTags = textCopy.matchAll(regex);
  const clinic_routes = {
    products: 'products/:service',
  };
  for (const mustacheTag of mustacheTags) {
    const { tag, text } = mustacheTag.groups;
    let { to, data } = mustacheTag.groups;
    if (tag === 'LINK') {
      data = JSON.parse(data);
      if (Object.keys(data).length) {
        to = clinic_routes[to];
        regex = new RegExp(':(?<key>[a-zA-Z_]+)', 'g');
        const uiSrefParams = to.matchAll(regex);
        for (const params of uiSrefParams) {
          to = to.replaceAll(params[0], data[params.groups.key]);
        }
      }
    }
    const anchorEl = `<a>${text}</a>`;
    const tooltip = `<md-tooltip md-direction="bottom" md-z-index="100000">${to}</md-tooltip>`;
    const container = `<span>${anchorEl}${tooltip}</span>`;
    textCopy = textCopy.replaceAll(mustacheTag[0], container);
  }
  return textCopy;
});
